import * as v from "@thi.ng/vectors";
import { Molecule } from "./structure";

export function tick(
  molecule: Molecule,
  t: number,
  lastT: number,
  cursorPosition: v.Vec2 | null,
) {
  const dt = t - lastT;
  for (const atom of molecule.atoms) {
    // Apply slight force based on sine float
    const sineFloatPeriodMS = 5000;
    const sineFloatMagnitude = 0.00015;
    const sineFloatForce =
      sineFloatMagnitude *
      Math.sin(
        (t / sineFloatPeriodMS + atom.id / molecule.atoms.length) * 2 * Math.PI,
      );
    v.add2(null, atom.currentLocation, v.vec2(0, sineFloatForce * dt));

    // Apply a repelling force based on the cursor
    if (cursorPosition != null) {
      const distanceFromCursor = v.sub2(
        [],
        atom.currentLocation,
        cursorPosition,
      );
      const cursorRepellingMagnitude = 0.009;
      v.add2(
        null,
        atom.currentLocation,
        v.mulN2(
          null,
          v.normalize2([], distanceFromCursor),
          cursorRepellingMagnitude,
        ),
      );
    }

    // Apply force based on distance to home
    const distanceToHome = v.sub2([], atom.currentLocation, atom.home);
    const homeDistanceMagnitude = 0.008;
    const homeDistanceForce = v.neg2(
      null,
      v.mulN2([], distanceToHome, homeDistanceMagnitude),
    );
    v.add2(null, atom.currentLocation, homeDistanceForce);
  }
}
